<div class="budget-status" [ngClass]="{'synced': isPlanInSync && isBudgetInSync, 'unsynced': !isPlanInSync || !isBudgetInSync}">

  @if (!isPlanInSync) {
    <mat-card class="daxa-card border-radius bg-white border-none budget-summary-card">
      <mat-card-content>
        <div class="status-content">
          <div class="status-text">
            <mat-icon color="warn">error</mat-icon>
            <span class="status-not-ok">Proračun nije usklađen</span>
          </div>
          <div class="status-amounts">
            <span>
              <strong>Ukupno traženo (Općina + ostali izvori):</strong>
              {{ totalCostsRequested + totalFundingFromOtherSources | currency:'EUR' }}
            </span>
            <span>
              <strong>Stvarni ukupni troškovi (A+B):</strong>
              {{ totalCostsActual | currency:'EUR' }}
            </span>
            @if (planDifference !== 0) {
              <span>
                <strong>Razlika:</strong>
                {{ planDifference | currency:'EUR' }}
                @if (isPlanShort) {
                  (Potrebno još {{ planDifference | currency:'EUR' }} za pokrivanje troškova)
                }
                @if (isPlanOver) {
                  (Traženo je {{ (-planDifference) | currency:'EUR' }} više od stvarnih troškova)
                }
              </span>
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  } @else {
    @if (!isBudgetInSync) {
      <mat-card class="daxa-card border-radius bg-white border-none budget-summary-card">
        <mat-card-content>
          <div class="status-content">
            <div class="status-text">
              <mat-icon color="warn">error</mat-icon>
              <span class="status-not-ok">Proračun nije usklađen</span>
            </div>
            <div class="status-amounts">
              <span>Odobreni iznos: {{ projectApprovedAmount | currency:'EUR' }}</span>
              <span>Sveukupno traženo od Općine (A + B): {{ totalCostsRequested | currency:'EUR' }}</span>
              <span>Razlika: {{ budgetDifference | currency:'EUR' }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    } @else {
      <mat-card class="daxa-card border-radius bg-white border-none budget-summary-card">
        <mat-card-content>
          <div class="status-content">
            <div class="status-text">
              <mat-icon color="primary">check_circle</mat-icon>
              <span class="status-ok">Proračun je usklađen</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }
  }

  <!-- If plan is in sync but budget validation fails, show the budget error card -->

  <!-- If both validations are in sync, show the success card -->
</div>